import { BlotterTableStorageContext } from '@talos/kyoko';
import type { PropsWithChildren } from 'react';
import type { LayoutPanelApi } from '../../../types';
import type { PanelBlottersState } from './panelPersistence';
import { usePanelBlotterTableStorage } from './usePanelBlotterTableStorage';

type PanelBlotterTableStorageProviderProps = PropsWithChildren<{
  panelApi: LayoutPanelApi;
  panelBlottersState?: PanelBlottersState;
}>;

/**
 * Overrides blotter table storage with a panel-param-backed implementation
 * so panel-based blotters persist state into dockview params.
 */
export function PanelBlotterTableStorageProvider({
  panelApi,
  panelBlottersState,
  children,
}: PanelBlotterTableStorageProviderProps) {
  const storage = usePanelBlotterTableStorage(panelBlottersState, panelApi);

  return <BlotterTableStorageContext.Provider value={storage}>{children}</BlotterTableStorageContext.Provider>;
}
